import styled from 'styled-components';
import { MdHome, MdEvent, MdSupervisorAccount, MdArrowDropDown, MdPerson, MdNotifications, MdShare, MdLanguage, MdModeEdit, MdSearch,MdAssignment,MdVpnKey,MdPeople, MdAddBox } from 'react-icons/md';
import { IoIosArrowForward, IoIosArrowBack,IoMdHelpCircle } from "react-icons/io";
import {CgWebsite} from 'react-icons/cg'
export const Mobile = styled.div`
height:100%;
@media(max-width:800px){
    margin-bottom:40px;
}

`

export const Container = styled.div`
    display:${props =>props.flex};
    flex-direction: column;
    position:relative;
`;

export const ContainerHeader = styled.div`
    display:${props =>props.flex};
    flex-direction: row;
    background-color: #ffffff;
    height: 60px;
    box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.75);
    padding: 10px 15px;
    justify-content: space-between;
    /* position:fixed; */
    width:100vw;
`;

export const ContainerBody = styled.div`
    height: calc(100vh - 60px);
    overflow:hidden;
`;

export const ContainerIconSoftware = styled.div`
    display:flex;
    flex-direction:row;
    align-items:center;
    width:60vw;
    /* @media(max-width:800px){
        >div {
            :nth-child(3){
            display:none;
            }
            :nth-child(4){
            display:none;
            }
            :nth-child(5){
            display:none;
            }
        }
    } */

`;

export const ContainerItensMenu = styled.div`
    display:flex;
    align-items:center;
    justify-content: space-evenly;
    width:300px;
`;

export const ContainerItem = styled.div`
    display:flex;
    align-items:center;
    cursor: pointer;
    color: ${props => props.ativo ? '#3a70e8' : '#333333'} ;
    padding: 5px;
    border-radius: 5px;
    transition: all .3s ease-in-out;

    :hover{
        background-color: #f3f3f3;
        transform: translateY(-2px);
    }
`;

export const IconMdHome = styled(MdHome)`
    font-size: 30px;
`;

export const IconMdEvent = styled(MdEvent)`
    font-size: 30px;
`;

export const IconMdSupervisorAccount = styled(MdSupervisorAccount)`
    font-size: 30px;
`;
export const IconMdPerson = styled(MdPerson)`
    font-size: 30px;
`;
export const IconMdNotifications = styled(MdNotifications)`
    font-size: 25px;
`;
export const IconMdShare = styled(MdShare)`
    font-size: 25px;
    margin-right:3px;
    @media(max-width:480px){
        display:block;
    }
`;
export const IconMdLanguage = styled(MdLanguage)`
    font-size: 30px;
    @media(max-width:480px){
        display:block;
    }
`;
export const IconMdAssignment = styled(MdAssignment)`
    font-size: 30px;
`;
export const IconMdBorderColor = styled(MdModeEdit)`
    font-size: ${props => props.fontsizer ? props.fontsizer : '25px'};
    @media(max-width:480px){
        display:none;
    }
`;
export const IconMdSearch = styled(MdSearch)`
    font-size: 30px;
`;
export const IconMdVpnKey = styled(MdVpnKey)`
    font-size: 30px;
`;

export const MeusPosts = styled.div`
    display:none;
    @media(max-width:600px){
        display:unset;
    }
`

export const ContainerBtnPerfilConfig = styled.div`
    display:flex;
    align-items:center;
    padding-left: 8px;
    border-radius: 5px;
    position: relative;
    color: ${props => props.subMenuUserIsOpen ? '#3a70e8' : '#000000d6'};
    ${props => props.subMenuUserIsOpen ? 'background: var(--backgroundColorHover);' : ''};


    :hover{
        transition-duration: .3s;
        background: var(--backgroundColorHover);
        cursor: pointer;
    }

    @media(max-width:800px){
        padding-left:0;
        margin: 0 5px;
    }

    > span {
        font-weight: 600;
        font-size: 16px;

    @media (max-width:900px){
        display:none
    }
    }

`;

export const SubMenu = styled.div`
    display: ${props => props.subMenuUserIsOpen ? 'flex' : 'none'};
    position: absolute;
    color: #333333d6;
    top: 45px;
    right: 1px;
    /* height: 200px; */
    width: 200px;
    background: #fff;
    box-shadow: 0px 0px 10px -4px rgba(0,0,0,0.75);
    border-radius: 5px;
    flex-direction: column;
    justify-content: flex-start;
    align-content: center;
    padding: 5px;

    > ul {
        list-style: none;


    }

`;

export const SubMenuLi = styled.li`

    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    padding: 10px 15px;
    border-radius: 5px;

    >span {
        font-size: 16px;
        font-weight: 500;
    }

    >svg {
        font-size: 30px;
        margin-right: 5px;
        padding: 5px;
        background:  var(--backgroundColorHover);
        border-radius: 50%;
    }

    :hover{
        background:  var(--backgroundColorHover);
    }

`

export const IconMdArrowDropDown = styled(MdArrowDropDown)`
    font-size: 35px;
    padding: 3px;
    border-radius: 50%;
    background:  var(--backgroundColorHover);
    margin-left: 5px;

    /* :hover{
        transition-duration: .3s;
        background: #cecece;
    } */
`;

export const ContainerBtnsHeadSide = styled.div`
    display:${props=>props.mobile?'none':'flex'};
    flex-direction: row;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: 600;
    background: var(--backgroundColorHover);
    border-radius: 50%;
    width: 35px;
    height: 35px;
    cursor: pointer;

    margin-left: 5px;

    @media(max-width:800px){
        margin-left:0px;
    }

    :hover{
        transition-duration: .3s;
        background: #cecece;
    }
    > a{
        >svg{
            vertical-align:middle;
        }
    }
`;

export const ContainerPopUpUsuarios = styled.div`
    position:absolute;
    top:1px;
    right:1px;
    width: 100px;
    height: 100px;
    background: red;
`;

export const DivBusca = styled.div`
    background-color:var(--backgroundColorHover);
    border-radius:5px;
    height:28px;
    display:flex;
    margin:0 5px;
    :focus{
        border: 1px solid blue!important;
        box-shadow: 0px 0px 3px 0px blue!important;
    }
    @media(max-width:800px){
        margin:0 15px;
    }
    >input {
        @media(max-width:800px){
            width:40vw!important;
        }
        :focus{
            border: 1px solid var(--backgroundColorHover)!important;
            box-shadow: 0px 0px 3px 0px var(--backgroundColorHover)!important;
        }
    }
`
export const miniaturaImgPerfil = styled.img`
    width:40px;
    border-radius:100px;
    margin-right:5px;

`

export const FotoPerfil = styled.img`
    width:40px;
    border-radius:100px;
    margin-right:5px;
    max-height:40px;
    min-height:40px;
    @media(max-width:800px){
        margin:3px;
    }
`
export const IconMdPeople = styled(MdPeople)`
    font-size:30px;
`
export const IconMdAddBox = styled(MdAddBox)`
    font-size:30px;
`
export const IconIoMdHelpCircle = styled(IoMdHelpCircle)`
    font-size:30px;
`
export const IconIoIosArrowForward = styled(IoIosArrowForward)`
    font-size:60px;
    position:absolute;
    right:0;
    top:50%;
    cursor: pointer;
`
export const IconIoIosArrowBack = styled(IoIosArrowBack)`
    font-size:60px;
    position:absolute;
    left:0;
    top:50%;
    cursor: pointer;
`
export const ImgHelper = styled.img`
    width:90%;
    @media(max-height:720px){
        width:80%;
    }

`
export const IconCgWebsite = styled(CgWebsite)`
    font-size:25px;

`
